


















import Element from '../../mixins/element';
import { Component } from 'vue-property-decorator';

import payment from 'payment';

@Component
export default class Expiry extends Element {
    public toMount() {
        this.onLoading(false);
        // tslint:disable-next-line
        this.$parent.$on('ExpiryForceInput', (data: string) => {
            (this.$refs.input as any).value = data;
            // tslint:disable-next-line
            (this.$refs.input as any).dispatchEvent(new CustomEvent('input', {}));
        });

        (this.$refs.input as any).onpaste = (e) => {
            this.$once('serialized', () => {
                const val = this.input.value.split('/');
                if (val.length === 2
                    && /^\d\d$/.test(val[0].trim())
                    && /^\d\d\d?\d?$/.test(val[0].trim())) {
                    const value = this.input.value.substr(0, 9);
                    this.input = {
                        value,
                    };
                } else {
                    this.toClear();
                }
            });
            this.$nextTick(() => {
                (this.$refs.input as any).dispatchEvent(new CustomEvent('input', {}));
            });
        };
        // payment works bad if use v-model
        (this.$refs as any).input.onchange = (e) => {
            this.input = { value: e.target.value };
            (this.$refs.input as any).dispatchEvent(new CustomEvent('input', {}));
        };

        payment.formatCardExpiry((this.$refs as any).input);
    }

    public toDestroy(): void {
        // destroyed
    }

    public toValidate(): boolean {
        const splited = this.input.value.split('/');
        const year = splited[1] ? +splited[1].trim() : 2100;
        return payment.fns.validateCardExpiry(this.input.value) && year < 2100;
    }

    public toClear(): void {
        this.input = {
          value: '',
        };
    }

    public toFocus(): void {
        (this.$refs as any).input.focus();
    }

    public toBlur(): void {
        (this.$refs as any).input.blur();
    }
}
